/* Just Catnip — footer newsletter without a page reload (site review round 3, 30 Sep 2026).
   The form is Shopify's own customer form (Klaviyo picks the subscriber up through its
   Shopify integration), so it is posted with fetch and Shopify's answer read back:
   a redirect to …?customer_posted=true on success, the page re-rendered with the field
   error on failure. The store's spam protection wants a captcha token on this form:
   Shopify's captcha script exposes Shopify.captcha.protect(form, callback), which takes
   over the submit, attaches the token and then calls the callback, so the fetch goes
   through that when it is present. If Shopify still steps in (a /challenge page or a
   "verifying your connection" interstitial) the form is submitted normally so the
   browser can clear it. Without JavaScript the form submits normally, as before. */
(function () {
  function init(form) {
    if (form.dataset.ready) return;
    form.dataset.ready = '1';
    var input = form.querySelector('input[type="email"]');
    var button = form.querySelector('button[type="submit"]');
    if (!input || !button) return;
    var protectedByShopify = false;

    function show(text, ok) {
      form.querySelectorAll('.signup-msg').forEach(function (m) { m.remove(); });
      var p = document.createElement('p');
      p.className = 'signup-msg ' + (ok ? 'is-success' : 'is-error');
      p.id = form.id + (ok ? '-success' : '-error');
      p.setAttribute('role', ok ? 'status' : 'alert');
      p.textContent = text;
      form.appendChild(p);
      input.setAttribute('aria-describedby', p.id);
      if (ok) input.removeAttribute('aria-invalid'); else input.setAttribute('aria-invalid', 'true');
    }

    function send() {
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      fetch(form.action, {
        method: 'POST',
        body: new FormData(form),
        credentials: 'same-origin',
        headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'text/html' }
      }).then(function (res) {
        var url = res.url || '';
        if (url.indexOf('/challenge') > -1 || !res.ok) { form.submit(); return; }
        if (url.indexOf('customer_posted=true') > -1) { show(form.dataset.success, true); form.reset(); return; }
        return res.text().then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var err = doc.querySelector('#' + form.id + '-error');
          if (err) show(err.textContent.replace(/\s+/g, ' ').trim(), false);
          else if (doc.querySelector('#' + form.id + '-success')) { show(form.dataset.success, true); form.reset(); }
          else show(form.dataset.error, false);
        });
      }).catch(function () {
        show(form.dataset.error, false);
      }).then(function () {
        button.disabled = false;
        button.removeAttribute('aria-busy');
      });
    }

    form.addEventListener('submit', function (e) {
      if (!window.fetch || !window.FormData || !window.DOMParser) return; /* old browsers: normal submit */
      if (protectedByShopify) return; /* Shopify's captcha listener owns this submit and calls send() */
      e.preventDefault();
      if (typeof form.reportValidity === 'function' && !form.reportValidity()) return;
      var captcha = window.Shopify && window.Shopify.captcha;
      if (captcha && typeof captcha.protect === 'function') {
        protectedByShopify = true;
        captcha.protect(form, send);
        if (typeof form.requestSubmit === 'function') form.requestSubmit(); else send();
        return;
      }
      send();
    });
  }
  function all() { document.querySelectorAll('form[data-signup]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
  document.addEventListener('shopify:section:load', all);
})();
